import { CardControlsComponent } from "./component"
import { consumeContext } from "../../lib/consume_context"
import { Game } from "../../lib/game"

export const CardControlsConsumer = consumeContext({
  Context: Game.Context,
  provideTo: "gameContext",
})(CardControlsComponent)
